import React from "react";
import { withStyles,Typography,FormControlLabel,Switch} from "@material-ui/core";
import {primaryColor} from "../../assets/jss/material-dashboard-react";


class CustomSwitch extends React.Component{
    constructor(props) {
        super(props);
    }

    state = {
        checked: false,
    };

    handleChange = event => {
        this.setState({ checked: event.target.checked });
        if(this.props.onChange){
            this.props.onChange(event.target.checked)
        }

    };


    render(){

        const {
            labelText,
            classes,
            error
        } = this.props

        console.log("error:",error)


        return(
            <div>
            <FormControlLabel
                control={
                    <Switch
                    color="primary"
                        checked={this.state.checked}
                        onChange={this.handleChange}
                        classes={{
                            //switchBase:classes.colorSwitchBase,
                            checked: classes.checked,
                            bar:classes.colorBar
                        }}

                        value="checked"
                    />
                }
                label={labelText}
                >

            </FormControlLabel>
                {error ?( <Typography style={styles.errorColor}>{error}</Typography>) : null}
            </div>
        )



    }






}



const styles={
    checked:{
        color:primaryColor,
        backgroundColor:primaryColor
    },
    bar:{
      backgroundColor:primaryColor
    },
    errorColor: {
        color:"#f44336",
        textAlign:"left"
    },
    checked:{},
    colorBar:{}
}



export default withStyles(styles)(CustomSwitch);


// WEBPACK FOOTER //
// ./src/components/CustomSwitch/CustomSwitch.jsx